var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9091 12H15.0909C14.8016 12 14.5241 12.1229 14.3195 12.3417C14.1149 12.5605 14 12.8572 14 13.1667V31.8333C14 32.1428 14.1149 32.4395 14.3195 32.6583C14.5241 32.8771 14.8016 33 15.0909 33H28.9091C29.1984 33 29.4759 32.8771 29.6805 32.6583C29.8851 32.4395 30 32.1428 30 31.8333V13.1667C30 12.8572 29.8851 12.5605 29.6805 12.3417C29.4759 12.1229 29.1984 12 28.9091 12V12ZM28.5455 31.4444H15.4545V13.5556H28.5455V31.4444Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10.0556C26 9.7756 25.8922 9.50712 25.7004 9.30917C25.5087 9.11121 25.2485 9 24.9773 9H12.0227C11.7515 9 11.4913 9.11121 11.2995 9.30917C11.1078 9.50712 11 9.7756 11 10.0556V26.9444C11 27.2244 11.1078 27.4929 11.2995 27.6908C11.4913 27.8888 11.7515 28 12.0227 28H12.3636V10.4074H26V10.0556Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.b7872908.svg";
export { ForwardRef as ReactComponent };